import React from "react";
import styled from "styled-components";
import PretendardText from "../../../../component/atoms/text/pretendardText";

const ReviewGrade = ({ rating }) => {
  return (
    <ReviewGradeContainer>
      <ReviewGradeRatingWrapper>
        <ReviewGradeStar
          src={
            Number(rating) >= 1
              ? "/assets/admin/icons/ico_star_fill.svg"
              : "/assets/admin/icons/ico_star.svg"
          }
          alt="star"
        />
        <ReviewGradeStar
          src={
            Number(rating) >= 2
              ? "/assets/admin/icons/ico_star_fill.svg"
              : "/assets/admin/icons/ico_star.svg"
          }
          alt="star"
        />
        <ReviewGradeStar
          src={
            Number(rating) >= 3
              ? "/assets/admin/icons/ico_star_fill.svg"
              : "/assets/admin/icons/ico_star.svg"
          }
          alt="star"
        />
        <ReviewGradeStar
          src={
            Number(rating) >= 4
              ? "/assets/admin/icons/ico_star_fill.svg"
              : "/assets/admin/icons/ico_star.svg"
          }
          alt="star"
        />
        <ReviewGradeStar
          src={
            Number(rating) >= 5
              ? "/assets/admin/icons/ico_star_fill.svg"
              : "/assets/admin/icons/ico_star.svg"
          }
          alt="star"
        />
      </ReviewGradeRatingWrapper>
      <ReviewGradeRatingText>{rating}</ReviewGradeRatingText>
    </ReviewGradeContainer>
  );
};

export default ReviewGrade;

const ReviewGradeContainer = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ReviewGradeRatingWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const ReviewGradeStar = styled.img.attrs((props) => ({}))`
  width: 18px;
  height: 18px;
`;

const ReviewGradeRatingText = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: rgba(181, 181, 181, 0.5);
`;
